import request from '@/utils/request'

// 获取订单列表数据
export async function api_getOrderPage(params) {
  return request({
    url: '/rest/payment/order/page',
    method: 'get',
    params,
  })
}
// 获取订单详情数据
export async function api_getOrder(params) {
  return request({
    url: '/rest/payment/order',
    method: 'get',
    params,
    loading: true
  })
}
// 退款
export async function api_getOrderRefund(params) {
  return request({
    url: '/rest/payment/order/refund',
    method: 'get',
    params,
  })
}
